import React from 'react';

const NotificationBadge = ({ count = 0, type = 'default', className = '', onClick }) => {
  if (!count || count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count;

  const typeClass =
    type === 'warning' ? 'warning' :
    type === 'error' ? 'error' : '';

  return (
    <span
      className={`notification-badge ${typeClass} ${className}`}
      onClick={onClick}
      aria-label={`${count} notifications`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;